import request from '@/router/axios';
//厂商列表
export const searchManufacturerList = () => {
  return request({
    url: '/svolt-ess-boss-service/manufacturer/searchManufacturerList',
    method: 'get'
  })
}
//添加厂商
export const addManufacturer = (data) => {
  return request({
    url: '/svolt-ess-boss-service/manufacturer/addManufacturer',
    method: 'post',
    data: data
  })
}
//修改厂商
export const updateManufacturer = (data) => {
  return request({
    url: '/svolt-ess-boss-service/manufacturer/updateManufacturer',
    method: 'post',
    data: data
  })
}

export default{
  searchManufacturerList,
  addManufacturer,
  updateManufacturer
}



// WEBPACK FOOTER //
// ./src/api/vendorManagement.js